import { useApi, useAuth } from "@keel/core";
import type { Health } from "./types";

/** Sidebar counter: connections that are down (red) or degraded (amber). */
export function useIntegrationBadge() {
  const { can } = useAuth();
  const { data } = useApi<Health[]>(can("integrations.messages.read") ? "/integrations" : null, {
    refetchInterval: 30_000,
  });
  const bad = (data ?? []).filter((i) => i.status === "down" || i.status === "degraded");
  if (!bad.length) return null;
  return {
    n: bad.length,
    tone: bad.some((i) => i.status === "down") ? ("danger" as const) : ("warn" as const),
  };
}
